import React from 'react';
import Title from '../../partials/title';
import ScrollAnimation from 'react-animate-on-scroll';

const Explanation = () => {
    return (
        <div className="margin-top-double">
            <div style={{ height: 30 }} />
            <ScrollAnimation animateIn="fadeInLeft" animateOnce={true} className="w3-content w3-container">
                <Title text="Challenge Sports 3v3 Tour Rankings" className="black" />
                <p className="margin-top">Challenge Sports is excited to introduce its NEW Ranking System. You have asked and we have listened. Many teams have requested that Challenge Sports assign a higher point value to our more competitive tournaments.. Due to this request we are now implementing a tiered tournament system. Going forward all tournaments will be categorized as one of the following (Gold, Silver, Bronze and Regionals).  Teams will earn points based on where they placed for each tournament type.  Point values will be scaled so as to award top finishers in the more difficult tournaments with higher point values. Team points accumulated for the tournament year will be used for the rankings for the National Championships. Teams that participated in the previous year’s National Championships will have those points added to their current tournament year total when establishing rankings for this year’s National Championships.</p>
                <p className="w3-red p-4 white">See below for an outline of the new points system. Tournament Type will now be listed on each individual tournament page.</p>
            </ScrollAnimation>

            <ScrollAnimation animateIn="fadeIn" animateOnce={true} className="w3-responsive bg-whiteish">
                <table className="w3-table w3-container w3-content w3-bordered font-12 bg-white" style={{ marginTop: '4em', marginBottom: '4em' }}>
                    <thead>
                        <tr className="w3-black small-header-font-768">
                            <th>FINISH</th>
                            <th className="text-center">NATIONALS</th>
                            <th className="text-center">REGIONALS</th>
                            <th className="text-center">GOLD</th>
                            <th className="text-center">SILVER</th>
                        </tr>
                    </thead>
                    <tbody className="small-header-font-768">
                        <tr className="">
                            <td>1st Place</td>
                            <td className="text-center">4000</td>
                            <td className="text-center">2500</td>
                            <td className="text-center">2000</td>
                            <td className="text-center">1500</td>
                        </tr>
                        <tr className="">
                            <td>2nd Place</td>
                            <td className="text-center">3000</td>
                            <td className="text-center">2000</td>
                            <td className="text-center">1500</td>
                            <td className="text-center">1000</td>
                        </tr>
                        <tr className="">
                            <td>3rd Place</td>
                            <td className="text-center">2000</td>
                            <td className="text-center">1500</td>
                            <td className="text-center">1000</td>
                            <td className="text-center">500</td>
                        </tr>
                        <tr>
                            <td>4th Place</td>
                            <td className="text-center">1000</td>
                            <td className="text-center">750</td>
                            <td className="text-center">500</td>
                            <td className="text-center">250</td>
                        </tr>
                        <tr>
                            <td>5th Place</td>
                            <td className="text-center">600</td>
                            <td className="text-center">300</td>
                            <td className="text-center">200</td>
                            <td className="text-center">100</td>
                        </tr>
                        <tr>
                            <td>6th Place</td>
                            <td className="text-center">400</td>
                            <td className="text-center">200</td>
                            <td className="text-center">100</td>
                            <td className="text-center">50</td>
                        </tr>
                        <tr>
                            <td>Consolation Win</td>
                            <td className="text-center">200</td>
                            <td className="text-center">100</td>
                            <td className="text-center">50</td>
                            <td className="text-center">25</td>
                        </tr>
                        <tr>
                            <td>Consolation Loss</td>
                            <td className="text-center">100</td>
                            <td className="text-center">50</td>
                            <td className="text-center">25</td>
                            <td className="text-center">10</td>
                        </tr>
                    </tbody>
                    <tbody>
                        <tr>
                            <td colSpan="5">* If an event doesn't have a 5th or 6th place then the Consolation points will be awarded intead.</td>
                        </tr>
                    </tbody>
                </table>
            </ScrollAnimation>

            <div className="bg-blackish pt-8 pb-8">
                <ScrollAnimation animateIn="zoomIn" animateOnce={true} className="w3-content w3-container">
                    <h1 className="white text-center hind">BONUS</h1>
                    <p className="white hind margin-top-double text-justify">Challenge Sports is also introducing a NEW way for teams to earn bonus points. Any team that participates in 3 or more Challenge Sports tournaments within a tour season will receive the following bonus points.</p>
                    <div className="d-flex row-column justify-content-center margin-top">
                        <div style={{ width: 250 }} className="align-self-center">
                            <Title text="300" className="white anton font-50" />
                            <p className="white margin-top margin-right line1">Bonus points after a team participates in its 3rd tournament</p>
                        </div>
                        <div style={{ width: 50, height: 10 }} />
                        <div style={{ width: 250 }} className="align-self-center">
                            <Title text="100" className="white anton font-50" />
                            <p className="white margin-top margin-right line1">Bonus points for each additional tournament</p>
                        </div>
                    </div>
                </ScrollAnimation>
            </div>
        </div>
    );
}

export default Explanation;


// WEBPACK FOOTER //
// ./src/components/rankings/partials/explanation.js